import './index.styl'
import Menu from './menu'
import React from 'react'
import { Table, Button, Row, Col } from 'react-bootstrap'
import TypeRow from './type-row'


class Component extends React.Component {
  constructor (props) {
    super(props)
  }

  setType (type) {
    const { actions } = this.props

    actions.setType(type.id)
    actions.push('/projects')
  }

  render () {
    const { types, fetched, actions, type } = this.props
    const rows = []

    if (fetched === false) {
      // Fetch the list of types...
      actions.fetchTypes()

      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Momentje...</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && types.length === 0) {
      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Geen beschikbare exports gevonden</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && types.length > 0) {
      types
      .filter(type => {
        if (type.hasOwnProperty('disabledForProject') && type.disabledForProject.indexOf(this.props.projectId) !== -1) {
          return false
        }

        if (type.hasOwnProperty('disabledUnlessProject')) {
          if (type.disabledUnlessProject.indexOf(this.props.projectId) !== -1) {
            return true
          } else {
            return false
          }
        }

        return type
      })
      .forEach((t, index) => {
        rows.push(<TypeRow type={t} key={index} active={t.id === type} click={(e) => { this.setType(t) }} />)
      })
    }

    return (
      <main>
        <section className="container">
          <Row>
            <Col xs={12}>
              {rows}
            </Col>
          </Row>
        </section>
      </main>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Types/index.js